import { Injectable, inject } from '@angular/core';
import type { TableTimeSeries } from '@clean-code/models';
import { MarketWidget, MarketWidgetDataSource } from '@clean-code/models';
import { EnumValue, ID } from '@clean-code/models/common';
import { Observable } from 'rxjs';
import { MarketWidgetDataService } from '../infrastructure/widget.data.service';

@Injectable({ providedIn: 'root' })
export class WidgetFacade {
  private service = inject(MarketWidgetDataService);

  getAll$(groupId: ID): Observable<MarketWidget[]> {
    return this.service.getAll$(groupId);
  }

  getById$(_id: ID) {
    return this.service.getById$(_id);
  }

  public timeFrames$(): Observable<EnumValue[]> {
    return this.service.timeFrames$();
  }

  public getDataSource(
    widget: MarketWidget,
    tableTimeSeries: TableTimeSeries,
  ): MarketWidgetDataSource {
    const dataSource = widget.dataSources.find(
      (x: MarketWidgetDataSource) =>
        x.settings.identifier.identifierId === tableTimeSeries.identifierId &&
        (x.settings.identifier.continuously === false ||
          (x.settings.identifier.continuously === true &&
            x.settings.identifier.adjustment === tableTimeSeries.adjustment)),
    );

    if (!dataSource) {
      throw new Error('cannot find dataSource');
    }

    return dataSource;
  }
}
